module.exports = __webpack_public_path__ + "img/hotchestnut_hair.a976fb07.jpg";